var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9805 5.99024C19.7207 5.99798 19.4741 6.10656 19.293 6.29298L9.00002 16.5859L5.70705 13.293C5.61491 13.197 5.50454 13.1204 5.38241 13.0676C5.26028 13.0148 5.12885 12.9869 4.99581 12.9856C4.86277 12.9842 4.7308 13.0094 4.60762 13.0597C4.48444 13.11 4.37254 13.1844 4.27846 13.2784C4.18438 13.3725 4.11002 13.4844 4.05973 13.6076C4.00944 13.7308 3.98423 13.8628 3.98559 13.9958C3.98694 14.1288 4.01483 14.2603 4.06761 14.3824C4.1204 14.5045 4.19702 14.6149 4.29299 14.707L8.29299 18.707C8.48054 18.8945 8.73485 18.9998 9.00002 18.9998C9.26519 18.9998 9.51951 18.8945 9.70705 18.707L20.7071 7.70704C20.8516 7.56658 20.9503 7.38574 20.9902 7.18822C21.0302 6.9907 21.0095 6.78571 20.931 6.60013C20.8524 6.41454 20.7197 6.25701 20.5501 6.14818C20.3805 6.03935 20.1819 5.9843 19.9805 5.99024Z",
    fill: "#2FB380"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.fa7e2dd77570e416cbf75a0ee7ace498.svg";
export { ForwardRef as ReactComponent };